import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import HostField from '../forms/host-field';

const useStyles = makeStyles((theme) => ({
  field: {
    marginBottom: theme.spacing(2),
  },
}));

const EventFormHost = ({ disabled, forceTouched, ...rest }) => {
  const classes = useStyles();

  return (
    <HostField
      name="hostType"
      label="Host"
      disabled={disabled}
      touched={forceTouched}
      className={classes.field}
      {...rest}
    />
  );
};

EventFormHost.propTypes = {
  disabled: PropTypes.bool.isRequired,
  forceTouched: PropTypes.bool.isRequired,
};

export default EventFormHost;
